import { listAgents } from '../../../api/agents';
import { listAgentChannels } from '../../../api/channels';
import { buildChannelOptionGroups } from '../utils/channelOptions';

export async function fetchChannelOptionGroups() {
  const agentsResponse = await listAgents({ page: 1, perPage: 100 });
  const agents = agentsResponse.data || [];

  const lineByCatalogId = {};
  agents.forEach((agent) => {
    const catalogId = agent.channel?.catalog_id;
    if (!catalogId) {
      return;
    }
    lineByCatalogId[catalogId] = {
      phoneNumber: agent.channel?.phone_number || null,
      externalChannelId: agent.channel?.external_channel_id || null,
    };
  });

  const channelResponses = await Promise.all(
    agents.map(async (agent) => {
      try {
        const response = await listAgentChannels(agent.id, { page: 1, perPage: 50 });
        return (response.data || []).map((channel) => ({ agent, channel }));
      } catch {
        return [];
      }
    })
  );

  const pairs = channelResponses.flat();
  const allGroups = buildChannelOptionGroups(pairs);
  const groups = allGroups.filter((group) => group.agentCount > 1);

  return { groups, lineByCatalogId };
}
